<template>
  <div class="px-0 pb-0 card-body">
    <div v-if="loading && filteredData.length === 0" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading AVIES EPON ONU data...</p>
    </div>
    <div class="table-responsive" v-else-if="filteredData.length > 0">
      
      <div class="card mb-4">
        <div class="card-body px-0 pt-0 pb-2 invoice">
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Port/ONU</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Name</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">PPPoE ID</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">MAC Address</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Type</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Distance</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Rx Power</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Last Down</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Reason</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in filteredData" :key="index">
                  <td class="align-middle text-center text-sm">
                    {{ data.port }}/{{ data.onu_id }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.name || 'N/A' }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span v-if="data.PPPOE_ID === 'Loading...'">
                      <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    </span>
                    <span v-else>
                      {{ data.PPPOE_ID ?? 'N/A' }}
                    </span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.mac }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.onu_type }} ({{ data.dev_type }})
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.distance }}m
                  </td>
                  <td class="align-middle text-center text-sm" >
                    {{ data.rx_power }}dBm
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDate(data.last_down_time) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.last_down_reason }}
                  </td>
                  <td class="text-center">
                    <soft-badge
                      class="p-1 rounded-1 cursor-pointer text-sm bg-danger bg-opacity-25"
                      variant="gradient"
                      size="sm"
                      >
                      {{ data.status }}
                    </soft-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Skalaton />
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "AviesEponTable",
  components: {
    Skalaton
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    filteredData: {
      type: Array,
      default: () => []
    },
    meta: {
      type: Object,
      default: () => ({
        total_count: 0,
        filtered_count: 0,
        sort_order: ''
      })
    },
    sortKey: {
      type: String,
      default: ""
    },
    sortOrder: {
      type: String,
      default: "asc"
    }
  },
  methods: {
    formatDate(dateTime) {
      if (!dateTime) return 'N/A';
      return dateTime.split(' ')[0]; // Just show date part
    },
    statusClass(status) {
      return {
        'bg-success': status === 'Online',
        'bg-danger': status === 'Disabled',
        'bg-warning': status === 'Offline'
      };
    }
  }
};
</script>

<style scoped>
td {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}
</style>